export const en_51 = { 
    "common": {
        "pay": "REDEEM CODE",
    },
    "send_balance": {
        "store_pin_payment_msg" :"Please select \"redeem code\" below to complete the transaction. Please check your email for the receipt."
    }
}